import { sample } from "es-toolkit";
import Swal from "sweetalert2";
import { setupApp } from "./app";

let version: string | undefined;

(async function () {
    const { app } = await setupApp(window.location.pathname);
    app.mount("#app");
    runVersionCheck(1);
})();

function getWaitTime(type: "long" | "short" | "dev") {
    if (import.meta.env.MODE !== "production") {
        type = "dev";
    }

    switch (type) {
        case "long":
            return sample([127, 131, 137, 139, 149, 151, 157, 163, 167, 173, 179, 181]);
        case "short":
            return sample([31, 37, 41, 43, 47, 53, 59, 61, 67, 71, 73, 79, 83, 89, 97]);
        case "dev":
            return sample([2, 3, 5, 7, 11]);
    }
}

function runVersionCheck(waitTime?: number) {
    if (waitTime === undefined) {
        waitTime = getWaitTime("short");
    }

    console.debug(`Running version check in ${waitTime} seconds ...`);
    setTimeout(checkVersionMismatch, waitTime * 1000);
}

async function checkVersionMismatch() {
    const latest = await getVersion();
    if (latest === undefined) {
        runVersionCheck();
        return;
    }

    if (version === undefined) {
        version = latest;
        runVersionCheck();
        return;
    }

    if (version !== latest) {
        console.log(`Version change detected ${version} -> ${latest}`);

        Swal.fire({
            icon: "warning",
            title: "UPDATE TERDETEKSI",
            text: "Muat ulang halaman sekarang untuk memastikan aplikasi berjalan lancar.",
            showCancelButton: true,
            confirmButtonText: "Muat Ulang Sekarang",
            cancelButtonText: "Ingatkan Lagi Nanti",
        }).then((result) => {
            if (result.isConfirmed) {
                window.location.reload();
            } else {
                runVersionCheck(getWaitTime("long"));
            }
        });
    } else {
        runVersionCheck();
        return;
    }
}

async function getVersion() {
    try {
        const version = await fetch("/api/version");
        return await version.text();
    } catch (_) {
        return undefined;
    }
}
